import { Quill } from 'react-quill';

function getMentionCharIndex(text, mentionDenotationChars) {
  return mentionDenotationChars.reduce(
    (prev, mentionChar) => {
      const mentionCharIndex = text.lastIndexOf(mentionChar);

      if (mentionCharIndex > prev.mentionCharIndex) {
        return {
          mentionChar,
          mentionCharIndex
        };
      }
      return {
        mentionChar: prev.mentionChar,
        mentionCharIndex: prev.mentionCharIndex
      };
    },
    { mentionChar: null, mentionCharIndex: -1 }
  );
}

function handleSearchText(str) {
  if (str.endsWith(".")) {
    return str;
  }
  const lastDot = str.lastIndexOf(".");
  return lastDot !== -1 ? str.slice(0, lastDot) : str;
}

class VariableMention {
  constructor(quill, options) {
    if (options.disableMention) return;
    this.quill = quill;
    this.options = options;
    this.showSelectionList = true;
    this.previousER=null;
    quill.on("editor-change", this.onTextChange);
  }

  onVariableSelect = (value, id, length, vtype, variableType, count, isComplexDesign, isShortMessage, placeHolderText, isRelationShip) => {
    if(isRelationShip){
      const previousER = this.previousER?.endsWith(".") ? this.previousER.slice(0, -1) : this.previousER;
      const format = this.quill.getFormat(this.mentionCharPos);
      this.quill.deleteText(this.mentionCharPos, this.cursorPosition - this.mentionCharPos, Quill.sources.USER);
      const lastEntity = placeHolderText.substring(placeHolderText.lastIndexOf('.') + 1);
      this.previousER = previousER?.split('.')?.length > 1 ? `${previousER}.${lastEntity}.` : `${placeHolderText}.`;
      this.quill.insertText(this.mentionCharPos, `$${this.previousER}`, Quill.sources.USER);
      this.quill.formatText(this.mentionCharPos, 3, format, Quill.sources.USER);
      this.quill.setSelection(this.mentionCharPos + this.previousER.length+1, Quill.sources.USER);
      const containerPos = this.quill.container.getBoundingClientRect();
      const mentionCharPos = this.quill.getBounds(this.mentionCharPos);
      this.options.toggleVariablePopup(
        true,
        this.previousER,
        mentionCharPos,
        containerPos
      );
    }else {
      let updatedPlaceHolder = placeHolderText;
      let parentEntity = null;
      let entityName = null;
      const previousER = this.previousER?.endsWith(".") ? this.previousER.slice(0, -1) : this.previousER;
      if(previousER){
        const lastIndex = previousER.lastIndexOf(".");
        parentEntity = previousER.substring(0, lastIndex);
        entityName = previousER.substring(lastIndex + 1);
        if (parentEntity.length > 0) {
          updatedPlaceHolder = `${parentEntity}.${placeHolderText}`;
        }
      }

      const format = this.quill.getFormat(this.mentionCharPos);
      this.quill.deleteText(this.mentionCharPos, this.cursorPosition - this.mentionCharPos, Quill.sources.USER);
      isComplexDesign && variableType === 'ListString' && this.quill.insertText(this.mentionCharPos - 1, '\n', Quill.sources.USER);
      this.quill.insertEmbed(this.mentionCharPos, "mention", {
        denotationChar: this.mentionChar,
        value,
        id,
        length,
        vtype,
        vname:value,
        variableType,
        count,
        styles: format,
        isEmail: this.options.isEmail,
        isComplexDesign: isComplexDesign,
        dateFormat : process.env.REACT_APP_VARIABLE_DATE_FORMAT,
        isShortMessage,
        placeHolderText: updatedPlaceHolder,
        ...(previousER && {parentEntity: parentEntity, entityName: entityName})
      }, Quill.sources.USER);
      this.quill.insertText(this.mentionCharPos + 1, (variableType === 'ListString' ||  variableType === 'ListDate') ? `\n` : " ", Quill.sources.USER);
      this.quill.formatText(this.mentionCharPos, 3, format, Quill.sources.USER);
      this.quill.setSelection(this.mentionCharPos + 2, Quill.sources.USER);
      this.showSelectionList = false;
    }
   
  }

  convertTextToVariable = () => {
    const range = this.quill.getSelection();
    this.quill.deleteText(range.index, range.length, Quill.sources.USER);
    this.quill.insertText(range.index, this.options.mentionDenotationChars[0], Quill.sources.USER);
    this.quill.setSelection(range.index + 1, Quill.sources.USER);
    this.quill.insertText(range.index + 1, "", Quill.sources.USER); // TO trigger text change
  }

  onTextChange = (event, range, source) => {
    if (event === "selection-change") {
      if (range == null) return;
      this.cursorPosition = range.index;
      const textBeforeCursor = this.quill.getText(this.cursorPosition - 50, 50); // Assumption that max length of variable is 10
      const { mentionChar, mentionCharIndex } = getMentionCharIndex(
        textBeforeCursor,
        this.options.mentionDenotationChars
      );
      if (this.previousER) {
        const mentionCharPos = this.cursorPosition - (textBeforeCursor.length - mentionCharIndex);
        const text = this.quill.getText(mentionCharPos + 1, this.previousER.length);
        if (text !== this.previousER) {
          this.previousER = null;
        }
      }
      this.mentionChar = mentionChar;
      if (mentionCharIndex !== -1) {
        this.mentionCharPos = this.cursorPosition - (textBeforeCursor.length - mentionCharIndex);
        this.textAfter = textBeforeCursor.substring(
          mentionCharIndex + mentionChar.length
        );
        this.showSelectionList = (this.textAfter.trim().length !== 0 && this.textAfter.lastIndexOf(" ") === -1) || (this.textAfter.trim().length === 0 && this.cursorPosition - this.mentionCharPos === this.textAfter.split(" ").length);
        if (this.textAfter.length >= 0 && this.showSelectionList) {
          const containerPos = this.quill.container.getBoundingClientRect();
          const mentionCharPos = this.quill.getBounds(this.mentionCharPos);
          this.previousER = handleSearchText(this.textAfter.trim());
          this.options.toggleVariablePopup(
            this.showSelectionList,
            this.textAfter.trim(),
            mentionCharPos,
            containerPos
          );
        } else {
          this.options.toggleVariablePopup(false);
        }
      } else {
        this.options.toggleVariablePopup(false);
      }
    }
  }

  resetPreviousER = () =>{
    this.previousER= null;
  }
}

export default VariableMention;